import React from 'react'
import illustration from '../../../../shared/assets/submitted-stub-illustration.svg'
import { ComplaintStatusBadge } from '../../ui/ComplaintStatusBadge'

export const TabSubmittedStub = () => {
  return (
    <div className={'flex flex-col items-center gap-[24px] pb-[44px]'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div className={'flex flex-col items-center'}>
            <h2 className={'text-center text-[24px]'}>No data</h2>
          </div>
          <div
            className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
          >
            <p className={'text-center text-focus-500'}>
              Submit a complaint to Google and track its progress status
            </p>
          </div>
        </div>
      </div>
      <div className={'grid max-w-[544px] grid-cols-3 justify-center gap-[32px]'}>
        <div className={'flex flex-col items-center gap-[8px]'}>
          <ComplaintStatusBadge status={'submitted'} />
          <p className={'text-center text-[13px] text-[#8E7CA7]'}>
            Complaint is awaiting response from Google Support
          </p>
        </div>
        <div className={'flex flex-col items-center gap-[8px]'}>
          <ComplaintStatusBadge status={'accepted'} />
          <p className={'text-center text-[13px] text-[#8E7CA7]'}>
            Google Support approved the complaint and will restrict the ads shortly
          </p>
        </div>
        <div className={'flex flex-col items-center gap-[8px]'}>
          <ComplaintStatusBadge status={'rejected'} />
          <p className={'text-center text-[13px] text-[#8E7CA7]'}>
            See the reason behind rejection and update your trademark information
          </p>
        </div>
      </div>
    </div>
  )
}
